import axios from "axios";

const appAxios = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  headers: {
    "Content-Type": "application/json",
    "Cache-Control": "no-cache",
    accept: "*/*",
  },
});

export default appAxios;
